module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sms",
    class: _vm.smsTheme
  }, [_c('div', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.smsTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    staticClass: "textarea",
    domProps: {
      "value": _vm.smsText
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:smsText', $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2659cb8f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/Sms.vue
// module id = 649
// module chunks = 42